import { render, staticRenderFns } from "./ArticleComponent.vue?vue&type=template&id=2fe0b795&scoped=true"
import script from "./ArticleComponent.vue?vue&type=script&lang=ts"
export * from "./ArticleComponent.vue?vue&type=script&lang=ts"
import style0 from "./ArticleComponent.vue?vue&type=style&index=0&id=2fe0b795&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe0b795",
  null
  
)

export default component.exports